module.exports = __webpack_public_path__ + "static/media/frog(3).d031692a.PNG";